module.exports = __webpack_public_path__ + "static/media/cartagena-19.a841c7d4.jpg";